import { Link } from "react-router-dom";

function TaxFilingExpectation() {
  return (
    <section className="shield-section">
      {/* Row 1 */}
      <div className="expectation-row">
        <h2 className="white-heading expectation-title left">What to Expect</h2>
        <div className="expectation-cards">
          <div className="expectation-card">
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/money_range.svg`}
              alt="Personalized pricing"
              className="expectation-card-icon"
            />
            <p className="expectation-card-description">
              Pricing is personalized based on your tax situation
            </p>
          </div>
          <div className="expectation-card">
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/table_eye.svg`}
              alt="Transparent pricing"
              className="expectation-card-icon"
            />
            <p className="expectation-card-description">
              Shown before any work begins
            </p>
          </div>
          <div className="expectation-card">
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/lock_person.svg`}
              alt="Price locked"
              className="expectation-card-icon"
            />
            <p className="expectation-card-description">Locked once approved</p>
          </div>
        </div>
      </div>

      {/* Row 2 */}
      <div className="expectation-row">
        <h2 className="white-heading expectation-title right">When it can change</h2>
        <div className="expectation-cards">
          <div className="expectation-card">
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/assignment.svg`}
              alt="New complexity"
              className="expectation-card-icon"
            />
            <p className="expectation-card-description">
              Only if new, previously undisclosed tax complexity appears
            </p>
          </div>
          <div className="expectation-card">
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/notifications_active_blue_light.svg`}
              alt="You're notified"
              className="expectation-card-icon"
            />
            <p className="expectation-card-description">
              You're notified before anything moves forward
            </p>
          </div>
          <div className="expectation-card">
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/alarm_on.svg`}
              alt="You decide"
              className="expectation-card-icon"
            />
            <p className="expectation-card-description">
              You decide whether to proceed
            </p>
          </div>
        </div>
      </div>

      {/* CTAs */}
      <div className="expectation-cta-container">
        <Link to="/sign-in" className="cta-button primary_light">
          Start Filing
        </Link>
        <Link to="/who-we-help" className="cta-button secondary">
          Who we help
        </Link>
      </div>
    </section>
  );
}

export default TaxFilingExpectation;
